import {
  AssignmentsIcon,
  CheckCircleIcon,
  DocumentIcon,
  FuelIcon,
  MeterHistoryIcon,
  Parts,
  UsersIcon,
  TelematicsIcon,
  VendorIcon,
  VihicleIcon,
  WarningIcon,
  WrenchIcon,
  EquipmentIcon,
  AlarmIcon,
  ReportIcon,
  DashboardIcon,
  GeneralIcon,
  ServiceIconSection,
  InventoryManagementIcon,
  ExpenseIcon,
  WarrantyIcon,
} from "Assets/index";
import {
  ASSIGNMENTS,
  FAULTS,
  ISSUE,
  METER_HISTORY,
  PAPERS,
  PART,
  PURCHASE_ORDER,
  UNITS,
  VENDORS,
  SERVICE_HISTORY,
  WORK_ORDERS,
  INSPECTIONS_HISTORY,
  INSPECTIONS_ITEM_FAILURES,
  FUEL_HISTORY,
  EQUIPMENTS,
  REMINDERS_SERVICES,
  REMINDERS_VEHICLES,
  REMINDERS_CONTACTS,
  REPORTS,
  DASHBOARD,
  CONTACTS,
  SAMSARA_DEVICES,
  SERVICE_TASKS,
  INSPECTIONS_FORMS,
  SCHEDULES,
  SETTINGS_FAULTS_RULES,
  EXPENSE,
  WARRANTY,
} from "./routes";
import { MODULES, PERMISSIONS } from "Shared/Types/permissions";

export const generalData = [
  {
    title: "General management",
    icon: GeneralIcon,
    subMenu: [
      {
        icon: DashboardIcon,
        isDropdown: false,
        title: "Dashboard",
        withNotificaion: true,
        notifcationsCount: 0,
        url: DASHBOARD,
        subMenu: [],
        modules: [MODULES.DASHBOARDS],
      },
      {
        icon: VihicleIcon,
        isDropdown: false,
        title: "Units",
        withNotificaion: true,
        notifcationsCount: 0,
        url: UNITS,
        subMenu: [],
        modules: [MODULES.VEHICLES],
      },
      {
        icon: UsersIcon,
        title: "Contacts",
        isDropdown: false,
        withNotificaion: false,
        notifcationsCount: 0,
        url: CONTACTS,
        modules: [MODULES.CONTACTS],
        subMenu: [],
      },
      {
        icon: TelematicsIcon,
        title: "Devices",
        isDropdown: false,
        withNotificaion: false,
        notifcationsCount: 0,
        url: SAMSARA_DEVICES,
        subMenu: [],
        modules: [MODULES.TELEMATICS_DEVICES],
      },
      {
        icon: AssignmentsIcon,
        title: "Assignment",
        isDropdown: false,
        withNotificaion: false,
        notifcationsCount: 0,
        url: ASSIGNMENTS,
        subMenu: [],
      },
      {
        icon: MeterHistoryIcon,
        title: "Meter History",
        isDropdown: false,
        withNotificaion: false,
        notifcationsCount: 0,
        url: METER_HISTORY,
        subMenu: [],
        modules: [MODULES.METER_ENTRIES],
      },
      {
        icon: FuelIcon,
        title: "Fuel History",
        isDropdown: true,
        withNotificaion: false,
        notifcationsCount: 0,
        url: FUEL_HISTORY,
        subMenu: [],
        modules: [MODULES.FUEL_ENTRIES],
      },
      {
        icon: ReportIcon,
        title: "Reports",
        isDropdown: false,
        withNotificaion: false,
        notifcationsCount: 0,
        url: REPORTS,
        subMenu: [],
        modules: [MODULES.REPORTS],
      },
      {
        icon: ExpenseIcon,
        title: "Expense",
        isDropdown: false,
        withNotificaion: false,
        notifcationsCount: 0,
        url: EXPENSE,
        subMenu: [],
        modules: [MODULES.EXPENSE_ENTRIES],
      },
      {
        icon: DocumentIcon,
        title: "Papers",
        isDropdown: false,
        withNotificaion: false,
        notifcationsCount: 0,
        url: PAPERS,
        subMenu: [],
        modules: [MODULES.DOCUMENTS],
      },

      {
        icon: WarrantyIcon,
        title: "Warranty",
        isDropdown: false,
        withNotificaion: false,
        notifcationsCount: 0,
        url: WARRANTY,
        subMenu: [],
        modules: [MODULES.WARRANTIES],
      },
    ],
  },
  {
    title: "Service management",
    icon: ServiceIconSection,
    subMenu: [
      {
        icon: CheckCircleIcon,
        title: "Inspections",
        isDropdown: false,
        withNotificaion: false,
        notifcationsCount: 0,
        url: INSPECTIONS_HISTORY,
        modules: [MODULES.INSPECTIONS, MODULES.SCHEDULES],
        subMenu: [
          {
            title: "History",
            url: INSPECTIONS_HISTORY,
            icon: null,
            permissions: [
              PERMISSIONS.VIEW_INSPECTIONS,
              PERMISSIONS.FULL_INSPECTIONS_ACCESS,
            ],
          },

          {
            title: "Forms",
            url: INSPECTIONS_FORMS,
            icon: null,
            permissions: [PERMISSIONS.MANAGE_INSPECTION_FORMS, PERMISSIONS.FULL_INSPECTIONS_ACCESS],
          },
          {
            title: "Item Failures",
            url: INSPECTIONS_ITEM_FAILURES,
            icon: null,
            permissions: [
              PERMISSIONS.VIEW_SUBMISSIONS_ITEM_FAILURES,
              PERMISSIONS.FULL_INSPECTIONS_ACCESS,
            ],
          },
          {
            title: "Schedules",
            url: SCHEDULES,
            icon: null,
            modules: [MODULES.SCHEDULES],
            permissions: [PERMISSIONS.VIEW_SCHEDULES, PERMISSIONS.FULL_SCHEDULES_ACCESS],
          },
        ],
      },
      {
        icon: WarningIcon,
        title: "Issue",
        isDropdown: false,
        withNotificaion: true,
        notifcationsCount: 0,
        url: ISSUE,
        modules: [MODULES.ISSUES, MODULES.FAULTS, MODULES.FUEL_ENTRIES, MODULES.FAULTS_RULES],
        subMenu: [
          {
            title: "Issue",
            url: ISSUE,
            icon: null,
            permissions: [
              PERMISSIONS.FULL_ISSUES_ACCESS,
              PERMISSIONS.VIEW_ISSUES,
            ],
          },
          {
            title: "Faults",
            url: FAULTS,
            icon: null,
            permissions: [
              PERMISSIONS.FULL_ISSUES_ACCESS,
              PERMISSIONS.FULL_FAULTS_ACCESS,
              PERMISSIONS.VIEW_FAULTS_RULES,
            ],
          },
          {
            title: "Fault rules",
            url: SETTINGS_FAULTS_RULES,
            icon: null,
            modules: [MODULES.FAULTS_RULES],
            permissions: [PERMISSIONS.FULL_FAULTS_RULES_ACCESS, PERMISSIONS.VIEW_FAULTS_RULES],
          },
        ],
      },
      {
        icon: WrenchIcon,
        title: "Service",
        isDropdown: false,
        withNotificaion: true,
        notifcationsCount: 0,
        url: SERVICE_HISTORY,
        modules: [
          MODULES.SERVICE_ENTRIES,
          MODULES.SERVICE_TASK_MANAGEMENT,
          MODULES.WORK_ORDERS,
        ],
        subMenu: [
          {
            title: "Service history",
            url: SERVICE_HISTORY,
            icon: null,
            permissions: [
              PERMISSIONS.VIEW_SERVICE_ENTRIES,
              PERMISSIONS.FULL_SERVICE_ENTRIES_ACCESS,
            ],
          },

          {
            title: "Service tasks",
            url: SERVICE_TASKS,
            icon: null,
            modules: [MODULES.SERVICE_TASK_MANAGEMENT],
            permissions: [PERMISSIONS.FULL_SERVICE_TASK_MANAGEMENT_ACCESS, PERMISSIONS.VIEW_SERVICE_TASKS],
          },
          {
            title: "Work orders",
            url: WORK_ORDERS,
            icon: null,
            permissions: [
              PERMISSIONS.FULL_SERVICE_ENTRIES_ACCESS,
              PERMISSIONS.FULL_WORK_ORDERS_ACCESS,
              PERMISSIONS.VIEW_WORK_ORDERS,
            ],
          },
        ],
      },
      {
        icon: AlarmIcon,
        title: "Reminder",
        isDropdown: false,
        withNotificaion: false,
        notifcationsCount: 0,
        url: REMINDERS_CONTACTS,
        modules: [
          MODULES.CONTACT_RENEWAL_REMINDERS,
          MODULES.VEHICLE_RENEWAL_REMINDERS,
          MODULES.VEHICLE_SERVICE_REMINDERS,
        ],
        subMenu: [
          {
            title: "Contact Renewal",
            url: REMINDERS_CONTACTS,
            icon: AlarmIcon,
            permissions: [
              PERMISSIONS.FULL_CONTACT_RENEWAL_REMINDERS_ACCESS,
              PERMISSIONS.VIEW_CONTACT_RENEWAL_REMINDERS,
            ],
          },
          {
            title: "Vehicle Renewal",
            url: REMINDERS_VEHICLES,
            icon: null,
            permissions: [
              PERMISSIONS.FULL_VEHICLE_RENEWAL_REMINDERS_ACCESS,
              PERMISSIONS.VIEW_VEHICLE_RENEWAL_REMINDERS,
            ],
          },
          {
            title: "Service Reminders",
            url: REMINDERS_SERVICES,
            icon: null,
            permissions: [
              PERMISSIONS.FULL_VEHICLE_SERVICE_REMINDERS_ACCESS,
              PERMISSIONS.VIEW_VEHICLE_SERVICE_REMINDERS,
            ],
          },
        ],
      },
    ],
  },
  {
    title: "Inventory management",
    icon: InventoryManagementIcon,
    subMenu: [
      {
        icon: EquipmentIcon,
        isDropdown: false,
        title: "Equipment",
        withNotificaion: false,
        notifcationsCount: 0,
        url: EQUIPMENTS,
        subMenu: [],
        modules: [MODULES.EQUIPMENTS],
      },
      {
        icon: VendorIcon,
        title: "Vendors",
        isDropdown: false,
        withNotificaion: false,
        notifcationsCount: 0,
        url: VENDORS,
        subMenu: [],
        modules: [MODULES.VENDORS],
      },
      {
        icon: Parts,
        title: "Part",
        isDropdown: true,
        withNotificaion: false,
        notifcationsCount: 0,
        url: PART,
        modules: [MODULES.INVENTORY, MODULES.PURCHASE_ORDERS],
        subMenu: [
          {
            title: "Parts",
            url: PART,
            icon: Parts,
            permissions: [
              PERMISSIONS.FULL_PARTS_ACCESS,
              PERMISSIONS.VIEW_PARTS,
            ],
          },
          {
            title: "Purchase Orders",
            url: PURCHASE_ORDER,
            icon: null,
            permissions: [
              PERMISSIONS.FULL_PARTS_ACCESS,
              PERMISSIONS.FULL_PURCHASE_ORDERS_ACCESS,
              PERMISSIONS.MANAGE_PURCHASE_ORDERS,
            ],
          },
        ],
      },
    ],
  },
];
